import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateCategory($companyId: ID!, $id: ID!, $attributes: CategoryAttributes!) {
    updateCategory(companyId: $companyId, id: $id, attributes: $attributes) {
      category {
        id
        ...UpdatedCategory
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedCategory on Category {
    id
    name
    fullname
    color
    parent { id name fullname color }
    mystroTestId
  }
`
